import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name: form.name,
          name: form.name,
          email: form.email,
          phone: form.phone,
          message: form.message,
        },
        PUBLIC_KEY,
      );
      setStatus("success");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>
          Contact Us | RK Overseas — Glass Exporter Firozabad, India
        </title>
        <meta
          name="description"
          content="Contact RK Overseas, Firozabad, India for bulk glass decorative accessories, export inquiries and business collaboration. Call +91 9557306306 or email us today."
        />
        <meta
          name="keywords"
          content="contact RK Overseas, glass exporter contact india, bulk glass order firozabad, glass decorative accessories inquiry india, handcrafted glass wholesale india"
        />
        <link rel="canonical" href="https://rkoverseasindia.com/contact" />
      </Helmet>

      <div className="page-banner">
        <h1>Contact Us</h1>
        <p className="breadcrumb">Home / Contact Us</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="contact__grid">
            <div className="contact__info">
              <p className="contact__eyebrow">Connect With Us</p>
              <h2>Let's Build Something Exceptional Together</h2>
              <div
                className="section-divider"
                style={{ margin: "16px 0 24px" }}
              />
              <p style={{ color: "var(--text-muted)", lineHeight: 1.8 }}>
                Whether you are looking to source premium glass décor, explore
                bulk orders, or discuss long-term business collaboration — our
                team at RK Overseas is ready to assist you. We ensure prompt
                communication and professional support.
              </p>

              <div className="contact__locations">
                <div className="contact__location">
                  <h4>🏭 Manufacturing Facility</h4>
                  <p>
                    RK Overseas, B-5,6 UPSIDC,
                    <br />
                    Firozabad – 283203, India
                  </p>
                  <a href="tel:+919557306306">📞 +91 9557306306</a>
                  <a href="mailto:skinirdosh@gmail.com">
                    ✉️ skinirdosh@gmail.com
                  </a>
                </div>

                <div className="contact__location">
                  <h4>🏢 Showroom</h4>
                  <p>
                    RK Overseas, B-5,6 UPSIDC,
                    <br />
                    Firozabad – 283203, India
                  </p>
                  <a href="tel:+919557306306">📞 +91 9557306306</a>
                  <a href="mailto:skinirdosh@gmail.com">
                    ✉️ skinirdosh@gmail.com
                  </a>
                </div>
              </div>
            </div>

            <div className="contact__form-wrap">
              <h3>Send an Inquiry</h3>
              <form className="contact__form" onSubmit={handleSubmit}>
                <div className="contact__form-row">
                  <div className="contact__field">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Full Name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="contact__field">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Business Email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="contact__field">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Your Contact Number"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="contact__field">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    placeholder="Tell us about your requirements..."
                    rows={6}
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                {status === "success" && (
                  <div className="contact__alert contact__alert--success">
                    ✅ Your message has been sent successfully! We'll get back
                    to you soon.
                  </div>
                )}

                {status === "error" && (
                  <div className="contact__alert contact__alert--error">
                    ❌ Something went wrong. Please try again or email us
                    directly.
                  </div>
                )}

                <button
                  type="submit"
                  className="btn-primary"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Submit Inquiry"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
